import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { BillingQueuePage } from '../../../../features/contracts/billing/queue-page'
import { billingQueueSearchSchema } from '../../../../features/contracts/search'

/** C4: the accountant's queue of READY instalments across contracts (contracts.bill). */
export const Route = createFileRoute('/_app/service/contracts/billing')({
  staticData: { crumb: 'serviceContractBilling' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'contracts.bill'),
  validateSearch: billingQueueSearchSchema,
  component: BillingQueuePage,
})
